import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import "./doumentmodal.scss";
import trashIcon from "../../assets/trash-icon.svg";

export default function DocumentConfirmationDialog({
  visible,
  closeModal,
  handleSave,
  isLoader,
}) {
  return (
    <div className="modal-main-container card flex justify-content-center align-items-center">
      <Dialog
        visible={visible}
        onHide={closeModal}
        className="document-delete-confirmation"
      >
        <div className=" empty__data__view--icon">
          <img
            className="users-card-icon-img"
            src={trashIcon}
            alt="Search Icon"
          />
        </div>
        <p className="delete-dialog-heading ">
          {`Are you sure you want to delete this file?`}
        </p>

        <div className="flex justify-content-center gap-2 mt-4">
          <button className="cancel-btns" onClick={closeModal}>
            Cancel
          </button>
          <Button
            label="Yes, delete"
            className="confirm-btn"
            onClick={handleSave}
            disabled={isLoader}
            loading={isLoader}
          />
        </div>
      </Dialog>
    </div>
  );
}
